import { OrderOperationType } from 'api/types/entity';
import { isFinanceProject } from 'config';
import { Stack } from 'libs/ui';
import {
  AdditionalParametersSection,
  ConfirmationDocumentSection,
  ExecutionPeriodSection,
  ExecutionTermsSection,
  FinancialInstrumentSection,
  SenderOrRecipientDetailsSection,
  TransactionVolumeSection,
  TransferVolumeSection,
} from 'modules/order/common/components/sections';

import { useCreateOrderContext } from '../../providers/OrderProvider';
import { ClientSection } from '../sections';

export const CreateOrderFormContent = () => {
  const { orderType } = useCreateOrderContext();

  const isPurchaseOrSale =
    orderType === OrderOperationType.SecuritiesPurchase ||
    orderType === OrderOperationType.SecuritiesSale;

  const isWithdrawalOrDeposit =
    orderType === OrderOperationType.SecuritiesWithdrawal ||
    orderType === OrderOperationType.SecuritiesDeposit;

  const isFinance = isFinanceProject();

  return (
    <Stack spacing={24}>
      <ClientSection />
      <ExecutionPeriodSection />
      <ExecutionTermsSection
        isShowAdditionalNotes
        isShowOperationKind={isWithdrawalOrDeposit}
        isShowOperationPurpose={isPurchaseOrSale && isFinance}
        isShowOrderType={isPurchaseOrSale}
        isShowYield={isPurchaseOrSale}
      />
      <FinancialInstrumentSection />
      {isPurchaseOrSale && <TransactionVolumeSection />}
      {isWithdrawalOrDeposit && <TransferVolumeSection />}
      {isWithdrawalOrDeposit && (
        <SenderOrRecipientDetailsSection type="sender" />
      )}
      {isWithdrawalOrDeposit && (
        <SenderOrRecipientDetailsSection type="recipient" />
      )}
      {isWithdrawalOrDeposit && <AdditionalParametersSection />}
      {isWithdrawalOrDeposit && <ConfirmationDocumentSection />}
    </Stack>
  );
};
